import { defineComponent as i, openBlock as o, createElementBlock as l, mergeProps as p, unref as e, renderSlot as u, createElementVNode as a, createCommentVNode as h } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconTextItalic"
}, _ = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = g(r);
    return (d, t) => (o(), l("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      u(d.$slots, "default"),
      e(n) === "bold" ? (o(), l("g", m, t[0] || (t[0] = [
        a("path", { d: "M204,56a12,12,0,0,1-12,12H160.65l-40,120H144a12,12,0,0,1,0,24H64a12,12,0,0,1,0-24H95.35l40-120H112a12,12,0,0,1,0-24h80A12,12,0,0,1,204,56Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (o(), l("g", f, t[1] || (t[1] = [
        a("path", {
          d: "M192,56,144,200H64L112,56Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }, null, -1)
      ]))) : e(n) === "fill" ? (o(), l("g", k, t[2] || (t[2] = [
        a("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM176,80H153.64l-34.29,96H136a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16h22.36l34.29-96H120a8,8,0,0,1,0-16h56a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (o(), l("g", M, t[3] || (t[3] = [
        a("path", { d: "M198,56a6,6,0,0,1-6,6H156.32l-44,132H144a6,6,0,0,1,0,12H64a6,6,0,0,1,0-12H99.68l44-132H112a6,6,0,0,1,0-12h80A6,6,0,0,1,198,56Z" }, null, -1)
      ]))) : e(n) === "regular" ? (o(), l("g", Z, t[4] || (t[4] = [
        a("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }, null, -1)
      ]))) : e(n) === "thin" ? (o(), l("g", w, t[5] || (t[5] = [
        a("path", { d: "M196,56a4,4,0,0,1-4,4H154.88L109.55,196H144a4,4,0,0,1,0,8H64a4,4,0,0,1,0-8h37.12L146.45,60H112a4,4,0,0,1,0-8h80A4,4,0,0,1,196,56Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  _ as default
};
